import type { LucideIcon } from 'lucide-react';
import { AlertTriangle, Info, CheckCircle2 } from 'lucide-react';

export type DialogVariant = 'danger' | 'warning' | 'info' | 'success' | 'primary';

export type DialogVariantStyle = {
  attentionLabel: string;
  headerGradient: string;
  headerBorder: string;
  attentionColor: string;
  titleColor: string;
  iconBg: string;
  iconShadow: string;
  closeColor: string;
  Icon: LucideIcon;
  confirmBg?: string;
  confirmShadow?: string;
};

export const DIALOG_VARIANTS: Record<DialogVariant, DialogVariantStyle> = {
  danger: {
    attentionLabel: 'Attention required',
    headerGradient: 'linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)',
    headerBorder: '#fecaca',
    attentionColor: '#b91c1c',
    titleColor: '#7f1d1d',
    iconBg: 'linear-gradient(145deg, #dc2626, #b91c1c)',
    iconShadow: '0 8px 24px rgba(220, 38, 38, 0.45)',
    closeColor: '#991b1b',
    Icon: AlertTriangle,
    confirmBg: 'linear-gradient(145deg, #dc2626, #b91c1c)',
    confirmShadow: '0 4px 14px rgba(220, 38, 38, 0.35)',
  },
  warning: {
    attentionLabel: 'Please review',
    headerGradient: 'linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)',
    headerBorder: '#fde68a',
    attentionColor: '#b45309',
    titleColor: '#92400e',
    iconBg: '#f59e0b',
    iconShadow: '0 4px 14px rgba(245, 158, 11, 0.45)',
    closeColor: '#92400e',
    Icon: AlertTriangle,
    confirmBg: 'linear-gradient(145deg, #d97706, #b45309)',
    confirmShadow: '0 4px 14px rgba(217, 119, 6, 0.35)',
  },
  info: {
    attentionLabel: 'Information',
    headerGradient: 'linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)',
    headerBorder: '#bfdbfe',
    attentionColor: '#1d4ed8',
    titleColor: '#1e3a8a',
    iconBg: 'linear-gradient(145deg, #3b82f6, #2563eb)',
    iconShadow: '0 6px 20px rgba(37, 99, 235, 0.35)',
    closeColor: '#1e40af',
    Icon: Info,
  },
  success: {
    attentionLabel: 'Success',
    headerGradient: 'linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%)',
    headerBorder: '#a7f3d0',
    attentionColor: '#047857',
    titleColor: '#065f46',
    iconBg: 'linear-gradient(145deg, #10b981, #059669)',
    iconShadow: '0 6px 20px rgba(16, 185, 129, 0.35)',
    closeColor: '#047857',
    Icon: CheckCircle2,
  },
  primary: {
    attentionLabel: 'Confirm action',
    headerGradient: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
    headerBorder: '#e2e8f0',
    attentionColor: '#475569',
    titleColor: '#0f172a',
    iconBg: 'var(--primary-color)',
    iconShadow: '0 6px 20px rgba(15, 23, 42, 0.15)',
    closeColor: '#64748b',
    Icon: Info,
  },
};